import { Reducer } from "redux";

import { PhysicianRecordsResponse } from "../models/Api/PhysicianDetails";
import { ReferralIntakePhysicianDetailsDispatchTypes } from "../models/DispatchTypes/PhysicianDetails";
import {
  GetPhysicianRecordsActionDispatchTypes,
  PhysicianTypeID,
} from "../constants/PhysicianDetails";
import { mergeObjects } from "../utils";

const initialState: PhysicianRecordsResponse = {
  loading: true,
  response: [
    {
      physicianId: 0,
      physicianName: "",
      physicianNpiId: "",
      streetName: "",
      zipCode: "",
      city: "",
      phoneNo: "",
      taxId: "",
      physicianState: "",
      address: "",
      physicianTypeId: PhysicianTypeID.DEFAULT,
    },
  ],
};

const PhysicianRecordsReducer: Reducer<
  PhysicianRecordsResponse,
  ReferralIntakePhysicianDetailsDispatchTypes
> = (state = initialState, action) => {
  
  const reset = () => ({
    loading: false,
    response: [],
  });

  switch (action.type) {
    case GetPhysicianRecordsActionDispatchTypes.GET_PHYSICIAN_RECORDS_INVOKE: {
      return mergeObjects(state, { loading: true });
    }
    case GetPhysicianRecordsActionDispatchTypes.RESET_PHYSICIAN_RECORDS: {
      return reset();
    }
    case GetPhysicianRecordsActionDispatchTypes.GET_PHYSICIAN_RECORDS_SUCCESS: {
      return mergeObjects(state, { response: action.response, loading: false });
    }
  }
  return state;
};

export default PhysicianRecordsReducer;
